// NOTE: This is a copy-paste from app-domain (cf. CodeEditorGroup) and adapted (remove zonefile related configuration)
import * as React from 'react';
import pick from 'lodash/pick';
import { useField } from 'react-final-form';
import { FinalFormGroup } from '@gandi/form/FinalForm';
import CodeEditor from './CodeEditor';
import { jsx as _jsx } from "react/jsx-runtime";
const editorPropList = ['className', 'contentAttributes', 'disabled', 'readOnly', 'onChange', 'height', 'initialValues', 'lang', 'type'];
const CodeEditorFieldGroup = ({
  name,
  ...rest
}) => {
  const {
    input,
    meta
  } = useField(name);
  // retrieve editor props from custom and injected redux-form props
  const inputProps = pick(input, editorPropList);
  const customProps = pick(rest, editorPropList);
  return (
    /*#__PURE__*/
    // $FlowFixMe[prop-missing] `className` is missing but unused
    _jsx(FinalFormGroup, {
      name: name,
      ...rest,
      children: /*#__PURE__*/_jsx(CodeEditor
      // force initial value
      , {
        initialValue: meta.initial,
        ...inputProps,
        ...customProps
      })
    })
  );
};
export default CodeEditorFieldGroup;